import React from "react"

import Layout from "../components/layout"
import Pills from "../images/pill-background.jpeg"
import AthelasOne from "../images/athelas-one.png"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <div className="hero">
      <div className="hero-left">
        <h1 className="header-text">Designed for Psychiatry</h1>
        <div className="hero-sub-header">
          Golden Gate is a full service specialty pharmacy designed for Psychiatrists.
        </div>
      </div>
      <div className="hero-right">
        <img src={Pills} alt='pills' className="hero-image" />
      </div>
    </div>
    <div className="section">
      <div className="sub-section-left">
        <img src={AthelasOne} alt='Athelas One device' className="section-image" />
      </div>
      <div className="sub-section-right">
        <div className="header-text">Integrated With Athelas One</div>
        <span className="hero-sub-header">
          Integrated with the Athelas One to make Clozapine patient management seamless.
        </span>
      </div>
    </div>
  </Layout>
)

export default IndexPage
